<template>
  <div v-if="progressActive">
    <div class="text-center">{{ progressTitle }}</div>
    <div class="progress task-progress">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        :aria-valuenow="progressPercent"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="'width: ' + progressPercent + '%'"
      >
        <strong>{{ Math.round(progressPercent) }} %</strong>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus";

export default {
  name: "background-task-progress",
  data() {
    return {
      progressPercent: 0,
      progressActive: false,
      progressTitle: ""
    };
  },
  created() {
    bus.$on("background-task-update", data => {
      this.progressPercent = data.percent;
      this.progressActive = data.active;
      this.progressTitle = data.title;
    });
  }
};
</script>
<style>
.task-progress {
  width: 300px;
  height: 20px;
}
</style>
